import { authSlice } from "./authSlice";
const { actions } = authSlice;

export const setUserAuth = (token) => dispatch => {
    dispatch(actions.setUserToken(token));
};